// extracted by mini-css-extract-plugin
module.exports = {"container":"breadcrumbs-module--container--3jmEE","item":"breadcrumbs-module--item--IozxI","link":"breadcrumbs-module--link--2wnOv","arrow":"breadcrumbs-module--arrow--20CbI"};